import { TYPE } from '../../constants/file-image-types';

export default function drawEditModalBody({
  id,
  name,
  type,
  parent_id,
  company_id,
  tags = '',
  path = '',
  show_company_id = true
}) {
  $('.folder-company-id').addClass('d-none');
  let html = '';

  if (type === TYPE.STOCK) {
      html = `
    <div class="modal-content modal-content-inner" data-grid-item-id='${name}' data-grid-item-type='${type}'>
      <label>Tags</label>
      <select class="form-control stock-image-tags" id="stock-image-tags" multiple="multiple" data-value="${tags}"></select>
      <input type="hidden" class="stock-image-path" id="stock-image-path" value="${path}" />
    </div>
    `;
    } else if (type === TYPE.FOLDER) {
    html = `
    <div class="modal-content modal-content-inner" data-grid-item-id='${id}' data-grid-item-type='${type}'>
      <div class="form-group">
        <label>Name</label>
        <input type="text" placeholder="Name" class="form-control item-name" value="${name}" />
      </div>
    </div>
    `;

    if (parent_id == 'null' && show_company_id) {
      $('.folder-company-id').removeClass('d-none');
      $('.item-company-id').val(company_id == 'null' ? '' : company_id);
    }
  } else {
      html = `
    <div class="modal-content modal-content-inner" data-grid-item-id='${id}' data-grid-item-type='${type}'>
      <input type="text" placeholder="Name" class="item-name" value="${name}" />
    </div>
    `;
    }

  return $(html);
}
